import React, { useState, useEffect } from "react";
import { Table, Button } from "react-bootstrap";
import { UserFavoritesRestaurantTableHead } from "../UserFavoritesTable/UserFavoritesRestaurantTableHead";
import { UserFavoritesRestaurantTablebody } from "../UserFavoritesTable/UserFavoritesRestaurantTablebody";
import BasicPagination from "../../../../Pagination/Pagination";
import { getUserActivity } from "../../../../../store/actions/SuperAdminVUserViewActivity/userViewsActivity";
import PropTypes from "prop-types";
import { connect, useSelector } from "react-redux";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import moment from "moment";
import isEmpty from "../../../../../store/validation/is-Empty";
import NoContent from "../../../../reusableComponents/NoContentComponent";

const UserFavoritesRestaurant = (props) => {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [sort, setSort] = useState("");

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const onErrorrGetRestaurant = () => {
    setLoading(false);
  };
  const onSuccesGetRestaurant = () => {
    setLoading(false);
  };

  useEffect(() => {
    if (!isEmpty(props.dateQuery)) {
      setLoading(true);
      let query = { ...props?.dateQuery, type: 1, reportType: "ACTIVITY" };
      props.getUserActivity(
        query,
        onSuccesGetRestaurant,
        onErrorrGetRestaurant
      );
    }
  }, [props.dateQuery]);

  const [restaurantFav, setRestaurantFav] = useState([]);

  useEffect(() => {
    if (!isEmpty(props.userRestaurantActivity)) {
      setRestaurantFav(props.userRestaurantActivity?.data);
    }
  }, [props.userRestaurantActivity]);

  useEffect(() => {
    if (!isEmpty(props.sortValue)) {
      setSort(props.sortValue);
    }
  }, [props.sortValue]);

  let filterData = [];
  if (sort === "A-Z") {
    filterData = restaurantFav.sort((a, b) => {
      if (a?.restaurant_id?.restaurant_name < b?.restaurant_id?.restaurant_name)
        return -1;
      if (a?.restaurant_id?.restaurant_name > b?.restaurant_id?.restaurant_name)
        return 1;
      return 0;
    });
  } else if (sort === "Z-A") {
    filterData = restaurantFav.sort((a, b) => {
      if (a?.restaurant_id?.restaurant_name < b?.restaurant_id?.restaurant_name)
        return 1;
      if (a?.restaurant_id?.restaurant_name > b?.restaurant_id?.restaurant_name)
        return -1;
      return 0;
    });
  }
  if (props.search) {
    let search = new RegExp(props.search, "i");
    filterData = restaurantFav.filter((getall) => {
      if (
        search.test(getall?.restaurant_id?.restaurant_name) ||
        search.test(getall?.user_id?.first_name) ||
        search.test(getall?.user_id?.last_name)
      ) {
        return getall;
      } else {
        return false;
      }
    });
  } else {
    filterData = restaurantFav;
  }

  const renderTableDataBody = (restaurant) => {
    return (
      <React.Fragment>
        <UserFavoritesRestaurantTablebody
          restaurantImage={
            restaurant.restaurant_id && restaurant.restaurant_id.logo_url
          }
          restaurantName={
            restaurant.restaurant_id && restaurant.restaurant_id.restaurant_name
          }
          restaurantId={
            restaurant.restaurant_id && restaurant.restaurant_id._id
          }
          userName={`${restaurant?.user_id?.first_name || ""} ${restaurant?.user_id?.last_name || ""
            }`}
          userDate={moment(restaurant.updatedAt).format("DD/MM/YYYY")}
          userTime={moment(restaurant.updatedAt).format("LT")}
          addedFood={restaurant?.viewed === true ? "Yes" : "No"}
          used={restaurant?.used === true ? "Yes" : "No"}
          status={restaurant?.user}
        />
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      {!loading ? (
        <>
          <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
            <Table className="HideShowTable enMinWidth900">
              <thead>
                <UserFavoritesRestaurantTableHead
                  headOne="Business ID"
                  headTwo="Business Name"
                  headThree="User Name"
                  headFour="Date - Time"
                  headFive="Viewed"
                  headSix="Used"
                />
              </thead>
              {filterData.length ?
                filterData
                  .slice(start, end)
                  .map((restaurant, index) => (
                    <tbody key={index}>{renderTableDataBody(restaurant)}</tbody>
                  )) : <NoContent />}
            </Table>
          </div>
          {filterData && filterData.length !== 0 ? (
            <BasicPagination
              totalRecords={filterData && filterData.length}
              limit={10}
              batch={page}
              onBatchChange={(e) => handleBatchChange(e)}
            />
          ) : (
            <> </>
          )}
        </>
      ) : (
        <AmealioLoader />
      )}
    </React.Fragment>
  );
};

UserFavoritesRestaurant.propTypes = {
  auth: PropTypes.object.isRequired,
  getUserActivity: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  userRestaurantActivity: state.userManagement.userRestaurantActivity,
});

export default connect(mapStateToProps, {
  getUserActivity,
})(UserFavoritesRestaurant);
